import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from 'reducers';

const persistConfig: any = {
  // key: process.env.REACT_APP_NAME,
  key: 'Textuin-310126',
  storage,
  blacklist: []
}

const persistedReducer = persistReducer(persistConfig, rootReducer)
const store = createStore(persistedReducer)
const persistor = persistStore(store)

export { store, persistor }